/**
 * @author Ivelin Ivanov
 */
var ciBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailContactInfoController = (function () {
    function DetailContactInfoController(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = false;
    }
    ;
    DetailContactInfoController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailContactInfoController.$inject = ['topic', 'settings'];
    return DetailContactInfoController;
}());
DetailContactInfoController = DetailContactInfoController;
var DetailContactInfoComponent = (function () {
    function DetailContactInfoComponent() {
        this.bindings = ciBind;
        this.templateUrl = 'detail-contact-info.html';
        this.controller = DetailContactInfoController;
    }
    return DetailContactInfoComponent;
}());
DetailContactInfoComponent = DetailContactInfoComponent;
angular
    .module('application')
    .component('detailContactInfo', new DetailContactInfoComponent());

//# sourceMappingURL=detail.general.ci.component.js.map
